import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import CardBlockLoadMore from "../../../components/CardBlockLoadMore/CardBlockLoadMore";
import IndexHeader from "components/Headers/IndexHeader.js";
import {
    searchProducts,
} from "../../../redux/actions/products_actions";
import { HOST_URL } from "../../../utils/misc";
import NProgress from 'nprogress';

const Search = (props) => {
  // Show value search
  let searchValue = JSON.parse(localStorage.getItem("searchValue")) 

  // State status loadmore
  const [input, setInput] = useState({
    page: 1
  })

  useEffect(() => {
    NProgress.start();
    // Scroll To Top
    window.scrollTo(0, 0)
    
    props.dispatch(searchProducts(input.page, searchValue))
  }, []);

  // props.<combine>.<reducer>.<action>.<properties>
  //  console.log(props.products.productSearch);

  // Handle Loadmore
  const loadMore = () => {
    let page = input.page + 1
    if(props.products.productSearch.totalPages >= page && props.products.productSearch){
      props.dispatch(searchProducts(
        page,
        searchValue,
        props.products.productSearch.searchResult
      )).then(() => {
        setInput((preState) => ({
          ...preState,
          page : page
        }))
      })
    }
    // console.log(props.products.productSearch.searchResult)
  }

  if(props.products.productSearch != undefined){
    NProgress.done();
    return (
      <>
        <IndexHeader title="TÌM KIẾM" imageUrl={HOST_URL + props.templates.templates.templateProperties.image_searchpage} minHeight="500" />
        <div className="container-fluid p-0">
            <div className="text-center productTitle"><b>Từ khóa tìm kiếm {searchValue}</b></div> 
            <div className="text-center">(có {props.products.productSearch.totalResult} kết quả)</div>
          <CardBlockLoadMore
            list={props.products.productSearch.searchResult}
            type="sofa"
            title="All Sofa Products"
            page={input.page}
            totalPages={props.products.productSearch.totalPages}
            loadMore = {() => loadMore()}    
          />
        </div>
      </>
    );
  }
  else{
    return(
      <>
        <IndexHeader title="TÌM KIẾM" imageUrl={HOST_URL + props.templates.templates.templateProperties.image_searchpage} minHeight="500" />
        <div className="container">
          <div className="row justify-content-center">
            <div className="text-center loadingSearch">
              <img src={HOST_URL + props.templates.templates.templateProperties.image_loading} style={{width: 150}} />        
            </div>
          </div>
        </div>
      </>
    )
  }
};

const mapStateToProps = (state) => {
  return {
    products: state.products,
    templates: state.templates,
  };
};

export default connect(mapStateToProps)(Search);
